module.exports = __webpack_public_path__ + "static/media/tools.f66fb612.jpg";